<template>
  <GridContainer class="footer-brand">
    <SvgIcon
      :aria-hidden="false"
      :image="IconLogo"
      class="footer-brand__logo"
      aria-label="Telekom Logo"
    />
  </GridContainer>
</template>
<script setup>
import { GridContainer } from '@i22team/td-longtail-vue-components';

import IconLogo from '~/assets/images/logo.svg';
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer-brand {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: $grid-base * 2 $grid-base $grid-base * 3;
  max-width: $max-navbar-width + $grid-base * 4;

  @include mq($mq-sm) {
    padding: 2 * $grid-base $grid-base;
  }

  @include mq($mq-md) {
    padding: $grid-base * 2;
  }

  &__logo {
    fill: currentColor;
    width: 45px;
    height: 38px;
  }
}
</style>
